import TomSelect from 'tom-select'

const JumpComboBoxHook = {
  mounted() {
    // The combo box makes use of 2 html select elements. One is managed by TomSelect, the other managed by live_view.
    // If you need to dynamically change the selections, you can trigger a reinit by sending the combo_box_force_reinit event.
    // This will destroy the TomSelect instance and re-initialize it with the new options. You can search
    // the codebase for this event to see how it's used. (e.g. socket |> push_event("combo_box_force_reinit", %{}))
    // This is necessary since the code has phx-update="ignore" on the TomSelect element.
    this.handleEvent('combo_box_force_reinit', () => {
      this.reInit()
    })
    this.init(this.el)
  },
  updated() {
    this.setRequiredAttributes()

    // If the options have changed, destroy the TomSelect instance and re-initialize it with the new options.
    const latestSelect = this.el.querySelector('select.combo-box-latest')
    const initialSelect = this.el.querySelector('select.combo-box')

    // Store custom options before comparison (only for create mode)
    const options = JSON.parse(this.el.dataset.options)
    let customOptions = []
    if (options.create && this.tomSelect) {
      // Get all options from Tom Select
      const allOptions = Object.keys(this.tomSelect.options)
      // Get server options from latestSelect
      const serverOptions = Array.from(latestSelect.options).map(opt => opt.value)
      // Find custom options (those not in server list)
      customOptions = allOptions.filter(opt => !serverOptions.includes(opt))
    }
    if (!initialSelect.multiple) {
      if (latestSelect.value && initialSelect.value && latestSelect.value !== initialSelect.value) {
        latestSelect.value = initialSelect.value
      } else if (latestSelect.value) {
        initialSelect.value = latestSelect.value
      } else if (initialSelect.value) {
        latestSelect.value = initialSelect.value
      }
    }

    let latestOptions = latestSelect.querySelectorAll('option')
    let initialOptions = initialSelect.querySelectorAll('option')

    // Convert latestOptions and initialOptions to arrays
    let latestOptionsArray = Array.from(latestOptions)
    let initialOptionsArray = Array.from(initialOptions)

    // Sort the arrays by their values
    latestOptionsArray.sort((a, b) => a.value.localeCompare(b.value))
    initialOptionsArray.sort((a, b) => a.value.localeCompare(b.value))

    if (latestOptionsArray && initialOptionsArray) {
      for (let i = 0; i < latestOptionsArray.length; i++) {
        const option1 = latestOptionsArray[i]
        const option2 = initialOptionsArray[i]

        if (!option2 || option1.label !== option2.label || option1.value !== option2.value) {
          // Store current selections before destroying
          const currentSelections = this.tomSelect ? this.tomSelect.getValue() : []

          this.tomSelect.destroy()
          initialSelect.innerHTML = latestSelect.innerHTML

          // Re-add custom options to the select before reinitializing
          if (customOptions.length > 0) {
            customOptions.forEach(optValue => {
              const option = document.createElement('option')
              option.value = optValue
              option.text = optValue
              option.selected = currentSelections.includes(optValue)
              initialSelect.appendChild(option)
            })
          }

          this.init(this.el)
          break
        }

        if (!initialSelect.multiple) {
          if (option1.selected !== option2.selected) {
            option2.selected = option1.selected
          }
        }
      }
    }
  },
  destroyed() {
    // Hide the first div child of this.el:
    this.el.querySelector('.combo-box-wrapper').classList.add('hidden')
    this.tomSelect && this.tomSelect.destroy()
  },
  reInit() {
    const latestSelect = this.el.querySelector("select.combo-box-latest");
    const initialSelect = this.el.querySelector("select.combo-box");

    this.tomSelect.destroy();
    initialSelect.innerHTML = latestSelect.innerHTML;
    this.init(this.el);
  },
  async init(el) {
    const remoteOptionsTarget = el.dataset.remoteOptionsTarget
    const options = JSON.parse(el.dataset.options)
    const plugins = JSON.parse(el.dataset.plugins)
    const globalOpts = window[el.dataset.globalOptions]
    const selectEl = el.querySelector('select.combo-box')
    const remoteOptionsEventName = el.dataset.remoteOptionsEventName

    const tomSelectOptions = {
      plugins,
      ...options,
      ...globalOpts,
    }

    if (remoteOptionsEventName) {
      tomSelectOptions.load = (query, callback) => {
        const handleServerReply = (payload, ref) => {
          const resultsJSON = payload.results.map(({ text, value }) => ({
            text,
            value,
          }))

          callback(resultsJSON)
        }

        // This calls the Phoenix Live View. Expects the results in this format: %{results: [{text: "text", value: "value"}]
        if (remoteOptionsTarget) {
          this.pushEventTo(remoteOptionsTarget, remoteOptionsEventName, query, handleServerReply)
        } else {
          this.pushEvent(remoteOptionsEventName, query, handleServerReply)
        }
      }
    }

    this.tomSelect = new TomSelect(selectEl, tomSelectOptions)

    el.querySelector('.combo-box-wrapper').classList.remove('opacity-0')
    var input = document.getElementById(`${selectEl.id}-ts-control`)
    if (input && options.focus) input.focus();

    this.setRequiredAttributes()
  },

  // Checks and updates required attributes on our `select` and `label`s based on data-required
  setRequiredAttributes() {
    const isRequired = this.el.hasAttribute('data-required')
    const label = this.el.querySelector('label')
    const select = this.el.querySelector('select.combo-box')

    if (isRequired) {
      label?.setAttribute('required', 'required')
      label?.classList.add('pc-label--required')
      select?.setAttribute('required', 'required')
    } else {
      label?.removeAttribute('required')
      label?.classList.remove('pc-label--required')
      select?.removeAttribute('required')
    }
  },
}

export default JumpComboBoxHook
